var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('janus-video-room',{attrs:{"room-data":{ id: _vm.$route.params.id },"user-data":_vm.$store.user,"stream-enabled":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }